export default function initModal() {
	const btnOpen = $('[data-modal="open"]');
	const btnClose = $('[data-modal="close"]');
	const containerModal = $('[data-modal="container"]');
	if (btnOpen || (btnClose && containerModal)) {
		function toggleModal(e) {
			e.preventDefault();
			containerModal.toggleClass('ativo');
			localStorage.setItem('modal', true);
		}

		function cliqueForaModal(e) {
			if (e.target === this) {
				toggleModal(e);
			}
			localStorage.setItem('modal', true);
		}
		btnOpen.on('click', function (e) {
			e.preventDefault();
			containerModal.toggleClass('ativo');
		});
		btnClose.on('click', function(e){
			toggleModal(e)
		});
		containerModal.on('click', function(e){
			cliqueForaModal(e)
		});
	}
}